export class SelectedTeamResult {
  name: string;
  businessUserId: string;
  selected: boolean;
}
